// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './router/permisson'

Vue.use(ElementUI)
Vue.config.productionTip = false


// 引入字典
import dict from '@/utils/dict.js'
Vue.prototype.$dict = dict
import prop from '@/utils/prop.js'
Vue.prototype.$prop = prop
// 引入通用函数
import fn from '@/utils/fn.js'
Vue.prototype.$fn = fn
// 引入道具函数
import item from '@/utils/itemFn.js'
Vue.prototype.$item = item
// 引入徽章属性
import badgeType from  '@/utils/badgeType';
Vue.prototype.$badgeType = badgeType
// 引入徽章基本信息
import badge from '@/utils/badge';
Vue.prototype.$badge = badge
// 引入徽章函数
import badgeFn from './utils/badgeFn';
Vue.prototype.$badgeFn = badgeFn
// 引入宝可梦信息
import pokemon from './utils/pokemon'
Vue.prototype.$pokemon = pokemon 
// 引入请求
import http from '@/utils/request'
Vue.prototype.$http = http

import VueSeamlessScroll from 'vue-seamless-scroll'

Vue.use(VueSeamlessScroll)


/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js